import React from 'react';
import { Button, Typography, Card } from 'antd';
import { LockOutlined } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { useSubscription } from '../../hooks/useSubscription';

const { Text, Title, Paragraph } = Typography;

const UpgradeCard = ({ title, paywallReason, buttonText }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const subscription = useSubscription();

  const handleUpgradeClick = () => {
    // If user has a subscription, go to subscription page, otherwise go to pricing
    if (subscription && subscription.hasSubscription()) {
      navigate('/subscription');
    } else {
      navigate('/pricing');
    }
  };

  return (
    <Card
      style={{
        maxWidth: '400px',
        marginTop: '48px',
        textAlign: 'center',
        border: '1px solid #e0e0e0',
        borderRadius: '12px',
        boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)',
        background: 'white'
      }}
      styles={{ body: { padding: '32px 24px' } }}
    >
      <LockOutlined 
        style={{ 
          fontSize: '30px', 
          color: 'var(--upgrade-color)', 
          marginBottom: '16px',
          display: 'block'
        }} 
      />
      
      <Title level={4} style={{ marginBottom: '12px', color: '#333' }}>
        {title}
      </Title>
      
      <Text style={{ 
        color: '#666', 
        fontSize: '16px', 
        lineHeight: '1.5',
        display: 'block',
        marginBottom: '24px'
      }}>
        { paywallReason }
      </Text>

      <Button
        type="primary"
        size="large"
        onClick={handleUpgradeClick}
        style={{
          backgroundColor: 'var(--upgrade-color)',
          borderColor: 'var(--upgrade-color)',
          height: '48px',
          fontSize: '16px',
          fontWeight: '600',
          padding: '0 32px',
          borderRadius: '8px'
        }}
      >
        {buttonText || t('case_upgrade.upgrade_button')}
      </Button>
      <Paragraph style={{ marginTop: '26px', marginBottom: '-3px ', color: '#666' }}>
        {t('note_card_upgrade.upgrade_hint')}
      </Paragraph>
    </Card>
  );
};

export default UpgradeCard; 